import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { datesHelper } from "@/shared/utils";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type RouteDetailsByTripDateAndTerminalsInput,
  routeDetailsByTripDateAndTerminalsInputSchema,
} from "./shared/routeDetails.input";
import {
  type RouteDetail,
  routeDetailSchema,
} from "./shared/routeDetails.output";

/**
 * Metadata for the fetchRouteDetailsByTripDateAndTerminals endpoint
 */
export const routeDetailsByTripDateAndTerminalsMeta = {
  functionName: "fetchRouteDetailsByTripDateAndTerminals",
  endpoint:
    "/routedetails/{TripDate}/{DepartingTerminalID}/{ArrivingTerminalID}",
  inputSchema: routeDetailsByTripDateAndTerminalsInputSchema,
  outputSchema: routeDetailSchema.array(),
  sampleParams: {
    TripDate: datesHelper.tomorrow(),
    DepartingTerminalID: 1,
    ArrivingTerminalID: 10,
  },
  endpointDescription:
    "List detailed route information for terminal pair on date.",
} satisfies EndpointMeta<
  RouteDetailsByTripDateAndTerminalsInput,
  RouteDetail[]
>;

/**
 * Fetch function for retrieving detailed route information for terminal pair on date
 */
const { fetch, useHook } = createFetchAndHook<
  RouteDetailsByTripDateAndTerminalsInput,
  RouteDetail[]
>({
  api: wsfScheduleApiMeta,
  endpoint: routeDetailsByTripDateAndTerminalsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/routeDetails.endpoints").routeDetailsGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving detailed route information for terminal pair on date
 */
export const fetchRouteDetailsByTripDateAndTerminals: FetchFactory<
  RouteDetailsByTripDateAndTerminalsInput,
  RouteDetail[]
> = fetch;

/**
 * React Query hook for retrieving detailed route information for terminal pair on date
 */
export const useRouteDetailsByTripDateAndTerminals: HookFactory<
  RouteDetailsByTripDateAndTerminalsInput,
  RouteDetail[]
> = useHook;
